import React, { useCallback } from 'react'

import {
  loadPane,
  updatePane,
} from '@disco/state-management/actions/ExplorerActions'
import { selectExplorerItems } from '@disco/state-management/actions/SelectionActions'
import { getExplorerSelection } from '@disco/state-management/selectors/selection'

import type { Artist } from 'types/artist'
import type { ExplorerPane } from 'types/explorer'

// import { handleModifierKeysSelection } from '@disco/utils/selection'
import ArtistInfo from 'components/common/artist-info'
import Button from 'components/ui/button'
import { HoverProvider } from 'components/ui/hover-provider'
import type { PaneItemAppearance } from 'components/ui/pane-item'
import PaneItem from 'components/ui/pane-item'
import Tooltip from 'components/ui/tooltip'

import { useDispatch, useSelector } from 'hooks/use-redux'

type Props = {
  appearance?: PaneItemAppearance
  artist: Artist | null | undefined
  index: number
  pane: ExplorerPane
  itemPrefix?: string
}

const ExplorerArtist = ({
  appearance,
  artist,
  index,
  pane,
  itemPrefix = 'pane',
}: Props): React.ReactNode => {
  const dispatch = useDispatch()
  const explorerSelection: Record<string, any> =
    useSelector(getExplorerSelection)
  const boundSelectExplorerItems = useCallback(
    (pane, selectionRange, selectionType) =>
      dispatch(selectExplorerItems(pane, selectionRange, selectionType)),
    [dispatch],
  )
  const handleClick = useCallback(
    (event: MouseEvent) => {
      if (!artist) return
      event.preventDefault()
      // TODO: Enable multi-select later
      // use new implementation from https://bitbucket.org/leveltwomusic/disco-apps/pull-requests/1907
      // // handle selection actions
      // if (event.metaKey || event.ctrlKey || event.shiftKey) {
      //   handleModifierKeysSelection(event, {
      //     selection: explorerSelection,
      //     index,
      //     pane,
      //     selectItems: boundSelectExplorerItems,
      //   })
      //   return
      // }
      // // handle regular clicks, regular click reset selection
      // dispatch(resetSelection())
      dispatch(updatePane({ ...pane, activeItem: `${itemPrefix}/${index}` }))
      dispatch(
        loadPane({
          artistId: artist.id,
          index: pane.index + 1,
          title: artist.name,
          type: 'artist',
          url: `/api/artist/${artist.id}/`,
        }),
      )
    },
    [
      artist,
      boundSelectExplorerItems,
      dispatch,
      explorerSelection,
      pane,
      index,
    ],
  )
  return (
    <HoverProvider>
      <PaneItem
        appearance={appearance}
        content={<ArtistInfo artist={artist} />}
        actions={
          <Tooltip content="Edit profile">
            <Button
              appearance="icon"
              compact
              icon="edit"
              link={
                artist
                  ? {
                      pathname: `/explorer/artists/${artist.id}`,
                      state: {
                        modal: true,
                        returnTo: '/',
                      },
                    }
                  : undefined
              }
            />
          </Tooltip>
        }
        onClick={handleClick}
      />
    </HoverProvider>
  )
}

export default ExplorerArtist
